import { render, staticRenderFns } from "./i-table-edit.vue?vue&type=template&id=6c0a4d1d&scoped=true&"
import script from "./i-table-edit.vue?vue&type=script&lang=js&"
export * from "./i-table-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a4d1d",
  null
  
)

export default component.exports